import { cn } from '@bem-react/classname';

export const cnUserAvatar = cn('UserAvatar');
